export const feedResources = {
  record: 'compose:record',
  reminder: 'system:reminder',
}
